document.addEventListener('DOMContentLoaded', function () {
  function initXLNotice(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.product-section');

    sections.forEach(function (section) {
      if (section.dataset.xlNoticeInit === '1') return;
      section.dataset.xlNoticeInit = '1';

      var notice = section.querySelector('.xl-seam-notice');
      if (!notice) return;

      var variantSelect = section.querySelector('select[name="id"][data-product-select]');
      if (!variantSelect) return;

      function updateNotice() {
        var selectedOption = variantSelect.options[variantSelect.selectedIndex];
        var selectedText = selectedOption ? selectedOption.text : '';
        notice.hidden = !/\b(?:XX?L|\d+\s*XL)\b/i.test(selectedText);
      }

      section.addEventListener('change', function (event) {
        if (
          event.target.matches('select[name="id"][data-product-select]') ||
          event.target.matches('input[data-variant-input]')
        ) {
          setTimeout(updateNotice, 30);
        }
      });

      updateNotice();
    });
  }

  initXLNotice(document);

  document.addEventListener('shopify:section:load', function (event) {
    initXLNotice(event.target);
  });
});